import { FC } from 'react';

import { useSecrets } from '@/Pages/Playground/PlaygroundHome/PlaygroundSecretsContext';
import { PlaygroundSecrets } from '@/Pages/Playground/components/PlaygroundSecrets';
import { TMessage } from '@/hooks/promptCanvas/types';

import Conversation from './Conversation';
import InputBar from './InputBar';

type TProps = {
  messages: TMessage[];
  metaprompt: string;
  setMetaprompt: (prompt: string) => void;
  isMutating: boolean;
  handleSubmit: (body: { improvement_instruction: string }) => void;
  openSecretsRef: React.MutableRefObject<(() => void) | null>;
};

const ChatPanel: FC<TProps> = ({
  messages,
  metaprompt,
  setMetaprompt,
  isMutating,
  handleSubmit,
  openSecretsRef,
}) => {
  const { setSecrets, dedicatedOpenAISecret } = useSecrets();

  return (
    <div className="flex h-full flex-col gap-2 bg-background py-3 pl-3 pr-3">
      <div className="flex max-h-[630px] flex-grow flex-col gap-2 overflow-y-auto pt-2">
        <div className="flex flex-col items-start gap-2">
          <div className="flex items-center gap-2">
            <span className="text-md font-medium text-secondary">
              INSTRUCTIONS
            </span>
            <PlaygroundSecrets
              value={{ OPENAI_API_KEY: dedicatedOpenAISecret }}
              onChange={setSecrets}
              usePortal={false}
              align="start"
              openSecretsRef={openSecretsRef}
            />
          </div>
          <span className="text-sm font-thin text-tertiary">
            Chat with an LLM agent to improve your prompt
          </span>
        </div>
        <Conversation chatHistory={messages} />
      </div>
      <InputBar
        metaprompt={metaprompt}
        setMetaprompt={setMetaprompt}
        isMutating={isMutating}
        onSubmit={() =>
          handleSubmit({
            improvement_instruction: metaprompt,
          })
        }
        autoFocus={true}
      />
    </div>
  );
};

export default ChatPanel;
